export const INITIAL_FILTERS = {
  user_id: "",
  name: "",
  email: "",
  contactNo: "",
  date_from: "",
  date_to: "",
  subscription: "",
  source: "",
  record_state: "",
  payment_method: "",
  currency: "",
  status: "",
  emailType: "",
  account_deleted: "",
};

export const LIMIT = 15;

export const ACCOUNT_DELETED_OPTIONS = [
  { value: "", name: "All Users" },
  { value: "yes", name: "Account Deleted" },
  { value: "no", name: "Active Account" },
];

export const RECORD_STATE_OPTIONS = [
  { value: "", name: "All States" },
  { value: "active", name: "Active" },
  { value: "expired", name: "Expired" },
  { value: "canceled", name: "Canceled" },
];

export const SOURCE_LABELS = {
  manual: "Manual",
  revenuecat: "RevenueCat",
};

export const PAYMENT_METHOD_OPTIONS = [
  { value: "", name: "All Payment Methods" },
  { value: "MANUAL_TRANSFER", name: "Manual Transfer" },
  { value: "BANK_ALFALAH", name: "Bank Alfalah (Card)" },
  { value: "PLAY_STORE", name: "Play Store (Android)" },
  { value: "APP_STORE", name: "App Store (iOS)" },
];

export const STATUS_OPTIONS = [
  { value: "", name: "All Statuses" },
  { value: "MANUAL", name: "Manual" },
  { value: "INITIAL_PURCHASE", name: "Initial Purchase" },
  { value: "RENEWAL", name: "Renewal" },
  { value: "CANCELLATION", name: "Cancellation" },
  { value: "SUBSCRIPTION_EXTENDED", name: "Extended" },
  { value: "PRODUCT_CHANGE", name: "Product Change" },
  { value: "BILLING_ISSUE", name: "Billing Issue" },
  { value: "EXPIRATION", name: "Expiration" },
  { value: "UNCANCELLATION", name: "Uncancellation" },
];
